var map = {
	"./SlideShow01.jpg": "0192",
	"./SlideShow02.jpg": "4902",
	"./SlideShow03.jpg": "1b66",
	"./SlideShow04.jpg": "cca6",
	"./SlideShow05.jpg": "0896",
	"./SlideShow06.jpg": "dd2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c9dc";